import { createAction } from 'redux-actions';
import { getSelectedProjectRequest } from 'api/selected-project-api';

const selectedProjectLoaded = createAction('SELECTED_PROJECT_LOADED'); //Duplicate: To avoid CD
export const setMergeSelectedProjectWithProjectList = createAction(
  'MERGE_SELECTED_PROJECT_WITH_PROJECT_LIST',
);
export const setUpdatedLegalHoldForSelectedProject = createAction(
  'UPDATE_LEGAL_HOLD_FOR_SELECTED_PROJECT',
);
const selectedProjectError = createAction('SELECTED_PROJECT_ERROR'); //duplicate: To avoid CD

/* This function has been created so that when user successfully creates a statement with legal hold option
we update the ProjectDetailsContainer along with ProjectListContainer So that we have the latest details
about the project selected. */
export const updatedSelectedProjectFromIDWithoutLoading =
  ({ projectId, contextKey }) =>
  async (dispatch, getState) => {
    const response = await getSelectedProjectRequest(projectId, contextKey);
    await dispatch(selectedProjectLoaded({ response }));
    const { id, legalHold } = response.data;
    dispatch(
      setMergeSelectedProjectWithProjectList({
        selectedProjectId: id,
        projectDetails: { legalHold },
      }),
    );
  };

export const updateSelectedProject =
  ({ projectId, clientLegalHold }) =>
  async (dispatch, getState) => {
    const { socketHasBeenDisconnected } = getState().sockets.projectSocket;
    try {
      // Check if the socket connection is active.
      if (!socketHasBeenDisconnected) {
        dispatch(
          setUpdatedLegalHoldForSelectedProject({
            projectDetails: { legalHold: clientLegalHold },
          }),
        );
        dispatch(
          setMergeSelectedProjectWithProjectList({
            selectedProjectId: projectId,
            projectDetails: { legalHold: clientLegalHold },
          }),
        );
      } else {
        dispatch(updatedSelectedProjectFromIDWithoutLoading({ projectId }));
      }
    } catch (error) {
      dispatch(selectedProjectError(error));
    }
  };
